export function AnimatedBackground({ variant = "default" }) {
  return (
    <div className={`animated-bg animated-bg--${variant}`} aria-hidden="true">
      <div className="animated-bg__blob animated-bg__blob--1" />
      <div className="animated-bg__blob animated-bg__blob--2" />
      <div className="animated-bg__blob animated-bg__blob--3" />
      <div className="animated-bg__geo animated-bg__geo--1" />
      <div className="animated-bg__geo animated-bg__geo--2" />
      <div className="animated-bg__geo animated-bg__geo--3" />
      <div className="animated-bg__geo animated-bg__geo--4" />
    </div>
  );
}
